import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface Promotion {
  id: number;
  title: string;
  description?: string;
  discount_percent?: number;
  discount_value?: number;
  promotion_type?: string;
  target_scope?: string;
  image?: string;
  icon?: string;
  start_date?: string;
  end_date?: string;
  active: boolean;
}

function Promocoes() {
  const [promotions, setPromotions] = useState<Promotion[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPromotions();
  }, []);

  const loadPromotions = async () => {
    setLoading(true);
    try {
      const response = await fetch(getApiEndpoint('/promotions?active=true'));
      const data = await response.json();
      setPromotions(data);
    } catch (error) {
      console.error('Erro ao carregar promoções:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="mobile-content">
        <div className="loading-message">Carregando promoções...</div>
      </div>
    );
  }

  return (
    <div className="mobile-content">
      <section className="promotions-section">
        <h2 className="section-title">Promoções</h2>
        {promotions.length === 0 ? (
          <div className="empty-message">Nenhuma promoção disponível no momento</div>
        ) : (
          <div className="promotions-list">
            {promotions.map((promotion) => (
              <div key={promotion.id} className="promotion-card">
                {promotion.image && (
                  <img
                    src={promotion.image}
                    alt={promotion.title}
                    className="promotion-image"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                    }}
                  />
                )}
                {promotion.icon && !promotion.image && (
                  <div className="promotion-icon">
                    <i className={`fas fa-${promotion.icon}`}></i>
                  </div>
                )}
                <div className="promotion-content">
                  <h3 className="promotion-title">{promotion.title}</h3>
                  {promotion.description && (
                    <p className="promotion-text">{promotion.description}</p>
                  )}
                  {promotion.discount_percent && (
                    <p className="promotion-discount">
                      Desconto de {promotion.discount_percent}%
                    </p>
                  )}
                  {promotion.discount_value && (
                    <p className="promotion-discount">
                      Desconto de R$ {promotion.discount_value.toFixed(2).replace('.', ',')}
                    </p>
                  )}
                  <Link to="/catalogo" className="promotion-btn">
                    Aproveitar
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default Promocoes;

